import type { FaireProductEntity } from "../../entity_types/product";

export const p_r222fabbmp: FaireProductEntity = {
  token: "p_r222fabbmp",
  type: "product",
  name: "A Heart So Full: Inspirational Messages for New Moms",
  brandToken: "b_x27fkb4h4a",
  brandName: "Paige Tate & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/66f7a708f7b3b91695a9cbc45569c5463d6a722aea7f827fa766b3898bd7629a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a29c42ea6cc14c83ab8a0cb5b9e47077679d004166e870e0c5f19b7f90eeb0f.jpeg",
    "https://cdn.faire.com/fastly/654b8b371155549450e2efe32598f60617caf31f69764f6cfe1c53f026f92efd.jpeg",
    "https://cdn.faire.com/fastly/279a27ed32c7dad1ba961123396d68ed38181330e241d0f49c99c87710a7991c.jpeg",
    "https://cdn.faire.com/fastly/3e8020814767e993236680acbff581c7470caf277350cc6bf356839ff3cb2fcf.jpeg",
    "https://cdn.faire.com/fastly/03c9d4d5e961708472bfd1724a80e5e0a584e8b7b37768a37e17456827f24348.jpeg",
  ],
  priceDollars: 9.97,
  description:
    "This book of inspirational quotes and original artwork gently guides you through your fourth trimester and empowers you to give yourself grace, accept your changing body, and trust your mothering intuition. Whether you're a first-time mom or having your next one, this book is the perfect pick-me-up whenever you need reassurance that you've got this.\n\n• Comforting daily reflections for the first 12 weeks after birth (broken out by weeks)\n• Encouraging messages touching upon everything from bonding with your baby to accepting changes to your body\n• Stylish hand-drawn lettering and illustrations\n• Beautiful soft-touch cover and original artwork\n• A great baby shower gift for anyone\n\nCATEGORIES: gifts for women, gift, books, love, baby shower, new mom gifts, books for adults, Faire Market 2026, mothers day",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:15.902Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
